import { render, staticRenderFns } from "./CompetitionStageHeader.vue?vue&type=template&id=88b72ce0&scoped=true"
import script from "./CompetitionStageHeader.vue?vue&type=script&lang=ts"
export * from "./CompetitionStageHeader.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionStageHeader.vue?vue&type=style&index=0&id=88b72ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b72ce0",
  null
  
)

export default component.exports